/**
 * Should be used with a HTML input as regex only test presence of TLD and position of "."
 */
export function isValidEmail(email: string): boolean {
    const emailRegex = /^[^.]+(\.[^.]+)*@[^.]+(\.[^.]+)*\.[^.]+$/;
    return emailRegex.test(email);
}
